<template>
  <nav v-if="isAuthenticated">
    <router-link to="/">Transcribe</router-link> |
    <router-link to="/upload">Upload</router-link> |
    <router-link to="/signin" @click="signOut">Signout</router-link>
  </nav>
  <router-view />
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { auth } from '@/plugins/firebase';

export default defineComponent({
  name: 'App',
  setup() {
    const store = useStore();
    const router = useRouter();

    const isAuthenticated = computed(() => store.getters['auth/isAuthenticated']);

    onMounted(() => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        store.dispatch('auth/setUser', currentUser);
      } else {
        store.dispatch('auth/clearUser');
      }
    });

    const signOut = async () => {
      try {
        await auth.signOut();
        store.dispatch('auth/clearUser');
        router.push('/signin');
      } catch (error) {
        console.error('Error signing out', error);
      }
    };

    return {
      isAuthenticated,
      signOut,
    }
  }
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
